import React from 'react';
import { IconSvgProps } from '@models/common';

const CheckMark: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'>
      <path
        d='M16.6667 5L7.5 14.1667L3.33333 10'
        stroke='currentColor'
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CheckMark;
